module.exports = __webpack_public_path__ + "img/68_33.96c3430f.png";